import styled from "styled-components";

export const ContainerListTechs = styled.ul`
  margin-top: 1.25rem;
  padding: 1.375rem;
  background-color: var(--color-gray-1);
  border-radius: var(--bd-radius);
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
